import React, { useEffect, useState, useRef } from "react";
import { ReactComponent, Utils } from "@formio/react";
import * as Constants from "../../../../common/constants.js";
import { GetFromEndPoint } from "../../../../common/general";
import settingsForm from "./GisMap.settingsForm";
import _ from "lodash";
import { createRoot } from "react-dom/client";
import Modal from "./Modal.jsx";
import { useTranslation } from "react-i18next";

/*
This component renders a GisMap 
*/
const GisMapCustomComp = ({ insideGrid, data, onChange, component, form }) => {
	const [mapToken, setMapToken] = useState("");
	const [mapCode, setMapCode] = useState("");
	const [longitude, setLongitude] = useState(null);
	const [latitude, setLatitude] = useState(null);
	const [address, setAddress] = useState(null);
	const [showMap, setShowMap] = useState(false);
	const [t, i18n] = useTranslation();
	const iframeRef = useRef(null);
	const modal = useRef();

	const showTheMap = () => {
		modal.current.open();
	};
	const hideTheMap = () => {
		setShowMap(false);
		modal.current.close();
	};

	// Call to backend to generate Gis token use in map url
	useEffect(() => {
		const GetSuccess = (responseObject) => {
			if (responseObject && responseObject.token) {
				setMapToken(responseObject.token);

			}
		};
		const GetFailure = (error) => {
			console.error(error);
		};

		var endpoint = Constants.GetGisTokenData;
		GetFromEndPoint(endpoint, null, null, GetSuccess, GetFailure);
	}, []);
	useEffect(() => {
		if (!mapToken) return;
		let gislink = "https://gis.mwan.gov.sa/MapLocator.V4/?token=" + mapToken;
		let initialValue = form._data[component.key] || component.defaultValue;
		// if we reopen the form location set with pointer on map.
		if (initialValue) {
			gislink += "&long=" + initialValue.longitude + "&lat=" + initialValue.latitude + "&address=" + initialValue.address;
			setLongitude(initialValue.longitude);
			setLatitude(initialValue.latitude);
			setAddress(initialValue.address);
		}

		setMapCode(`<iframe ref="${iframeRef}" src="${gislink}" height='500' width='100%' title='GisMap' id='includedPage'></iframe>`);
		// Where you want to render the map.
		// var element = document.getElementById("gis-map" + props.component.id);
		// if (element) {
		// 	element.innerHTML = `<iframe ref="${iframeRef}" src="${gislink}" height='500' width='100%' title='GisMap' id='includedPage'></iframe>`;
		// }
	}, [mapToken]);

	useEffect(() => {
		const iframe = document.getElementById("includedPage");

		const receiveMessage = (event) => {
			// Check if the message is from the iframe
			if (event.origin === "https://gis.mwan.gov.sa") {
				// receiving the message contains long and lat data
				const { long, lat, address } = event.data;
				setLongitude(long);
				setLatitude(lat);
				setAddress(address || "");
				onChange({ longitude: long, latitude: lat, address: address }, null);
				// console.log("Received long and lat:", long, lat);
				hideTheMap();
			}
		};
		// Ensure the iframe exists
		if (iframe) {
			// When the iframe loads

			window.addEventListener("message", receiveMessage);
		}
		return () => {
			window.removeEventListener("message", receiveMessage);
		};
	}, [mapCode]);

	//add page data in global form data
	useEffect(() => {
		if (data) {
			let keys = Object.keys(data);
			for (let i = 0; i < keys.length; i++) {
				form._data[keys[i]] = data[keys[i]];
				form._submission.data[keys[i]] = data[keys[i]];
			}
			if (insideGrid === true) {
				delete form._data[component.key];
				delete form._submission.data[component.key];
			}
		}
	}, [data]);

	return (
		<div id={"gis-map" + component.id}>
			<div className="row align-items-center">
				<div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2 mb-md-0 mt-4">
					<button onClick={showTheMap} className="btn btn-secondary w-100" disabled={component.disabled}>
						{t("Add Location")}
					</button>
				</div>
				{longitude != null && latitude != null && (
					<>
					
					  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
						<label style={{fontSize:"16px"}}>{t("Longitude")}:</label>
						{longitude !== null && longitude !== "" ? (
						  <p className="form-control-plaintext">{longitude}</p> // Display as label
						) : (
						  <input className="form-control" type="text" value={longitude || ""} onChange={(e) => setLongitude(e.target.value)} />
						)}
					  </div>
				  
					  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
						<label style={{fontSize:"16px"}}>{t("Latitude")}:</label>
						{latitude !== null && latitude !== "" ? (
						  <p className="form-control-plaintext">{latitude}</p> // Display as label
						) : (
						  <input className="form-control" type="text" value={latitude || ""} onChange={(e) => setLatitude(e.target.value)} />
						)}
					  </div>
				  
					  {component.setAddressField === "true" && (
						<div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
						  <label style={{fontSize:"16px"}}>{t("Address")}:</label>
						
							<input className="form-control" type="text" onChange={(e) => setAddress(e.target.value)} />
						  
						</div>
					  )}
					
				  </>
				  
				)}
			</div>

			<Modal ref={modal} buttonCaption="Okay" onClose={hideTheMap}>
				<button onClick={hideTheMap} style={{ position: "absolute", color: "#ffffff", backgroundColor: "#000000", top: 15, left: 60 }}>
					X
				</button>
				{React.createElement("div", {
					dangerouslySetInnerHTML: { __html: mapCode },
				})}
			</Modal>
		</div>
	);
};

export default class GisMap extends ReactComponent {
	static shouldSetValue = false; // Define shouldSetValue as a static property

	/**
	 * This is the first phase of component building where the component is instantiated.
	 *
	 * @param component - The component definition created from the settings form.
	 * @param options - Any options passed into the renderer.
	 * @param data - The submission data where this component's data exists.
	 */

	constructor(component, options, data) {
		options["oldState"] = {};
		super(component, options, data);
		this.reactInstance = null;
		this.setComponentState = this.setComponentState.bind(this);
	}

	/**
	 * This function is the default settings for the component. At a minimum you want to set the type to the registered
	 * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
	 *
	 * @param sources
	 * @returns {*}
	 */
	static schema(...extend) {
		return ReactComponent.schema({
			type: "gisMapCustomComp",
			label: "GisMap Information",
		});
	}
	static get builderInfo() {
		return {
			title: "GisMap Details",
			icon: "cubes",
			group: "Basic",
			documentation: "",
			weight: -10,
			schema: GisMap.schema(),
		};
	}
	static editForm = settingsForm;


	/**
	 * This method is called any time the component needs to be rebuilt. It is most frequently used to listen to other
	 * components using the this.on() function.
	 */
	init() {
		return super.init();
	}

	/**
	 * This method is called before the component is going to be destroyed, which is when the component instance is
	 * destroyed. This is different from detach which is when the component instance still exists but the dom instance is
	 * removed.
	 */
	destroy() {
		return super.destroy();
	}
	/**
	 * This method is called before a form is submitted.
	 * It is used to perform any necessary actions or checks before the form data is sent.
	 *
	 */

	beforeSubmit() {
		return super.beforeSubmit();
	}

	/**
	 * The second phase of component building where the component is rendered as an HTML string.
	 *
	 * @returns {string} - The return is the full string of the component
	 */
	render() {
		// For react components, we simply render as a div which will become the react instance.
		// By calling super.render(string) it will wrap the component with the needed wrappers to make it a full component.
		return super.render(`<div ref="react-${this.id}"></div>`);
	}

	/**
	 * Callback ref to store a reference to the node.
	 *
	 * @param element - the node
	 */
	setReactInstance(element) {
		this.reactInstance = element;
	}

	/**
	 * The third phase of component building where the component has been attached to the DOM as 'element' and is ready
	 * to have its javascript events attached.
	 *
	 * @param element
	 * @returns {Promise<void>} - Return a promise that resolves when the attach is complete.
	 */
	attach(element) {
		super.attach(element);
		// let randomId = getRandomId();
		// // The loadRefs function will find all dom elements that have the "ref" setting that match the object property.
		// // It can load a single element or multiple elements with the same ref.
		// this.loadRefs(element, {
		// 	[`react-${this.id}`]: "single",
		// });

		// if (this.refs[`react-${this.id}`]) {
		// 	this.attachReact(this.refs[`react-${this.id}`], this.setReactInstance.bind(this));
		// 	if (this.shouldSetValue) {
		// 		this.setValue(this.dataForSetting);
		// 		this.updateValue(this.dataForSetting);
		// 	}
		// }
		return Promise.resolve();
	}

	/**
	 * Override this function to insert your custom component.
	 *
	 * @param element
	 * @param ref - callback ref
	 */
	attachReact(element, ref) {
		let insideGrid = false;

		const root = createRoot(element);
		let key = this.component.key;

		const rootForm = this.getRoot(); // Get the root form object

		Utils.eachComponent(
			rootForm.components,
			function (component) {
				if (component.component.type === "editgrid") {
					Utils.eachComponent(
						component.component.components,
						function (component2) {
							if (!insideGrid) {
								insideGrid = component2.key === key;
							}
						},
						true
					);
				}
			},
			true
		);

		root.render(
			<GisMapCustomComp
				component={this.component} // These are the component settings if you want to use them to render the component.
				onChange={this.updateValue} // Pass the onChange event handler
				value={this.dataValue}
				data={this.data}
				form={rootForm}
				oldState={this.options["oldState"]}
				insideGrid={insideGrid}
				setComponentState={this.setComponentState}
			/>
		);
	}

	/**
	 * Override this function.
	 */
	detachReact(element) {
		return;
	}
	setComponentState = (value) => {
		this.options["oldState"] = { ...value };
		this.updateOnChange({}, true);
	};

}


